import React from "react";
import Classes from "./styles/style.module.css";
import CustomSwitch from "../../components/CustomSwitch";
import MoonIcon from "../../images/icons/moon.svg";

const ThemeHandler = () => {
  return (
    <div className={`${Classes.sideItem} disabled`}>
      <div className="d-flex align-items-center">
        <img src={MoonIcon} alt="moonIcon" />
        <p>تاریک </p>
      </div>
      <CustomSwitch value={false} OnChange={() => console.log("changed")} />
    </div>
  );
};

export default ThemeHandler;
